import { useContext } from 'react'
import update from 'immutability-helper'

import LegalConsentContext, { ILegalConsentContext } from './context'

export function useLegalConsent () {
  const contextValue = useContext<ILegalConsentContext>(LegalConsentContext)
  const { setContext, ...context } = contextValue

  function setShowLegalConsent (val: boolean) {
    setContext(prevContext => {
      return update(prevContext, {
        showLegalConsent: { $set: val }
      })
    })
  }

  return {
    ...context,
    setShowLegalConsent
  }
}
